export default "/static/img/layers/srtm30-colored-hillshade.0a988afa508ff8bed2d9fa06fa53714f.png";